import { render, staticRenderFns } from "./view.vue?vue&type=template&id=cc219f38&scoped=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"
import style0 from "./view.vue?vue&type=style&index=0&id=cc219f38&prod&scoped=true&lang=css"
import style1 from "./view.vue?vue&type=style&index=1&id=cc219f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc219f38",
  null
  
)

export default component.exports